import React, { FC } from 'react';
import PartWithIDDisplay from '../parts_detail_details_page/PartWithIDDisplay';
import StockedPartTag from '../parts_index_page/StockedPartTag';

const PartWithStockedDropdownDisplay: FC<any> = ({ part }) => {
	return (
		<div className="flex max-w-full flex-row items-center justify-between">
			<PartWithIDDisplay part={part} numberMaxChars={64} nameLengthPercentage={80} />
			<StockedPartTag isStocked={part.isStocked} />
		</div>
	);
};

export default PartWithStockedDropdownDisplay;
